import { useLocation } from "react-router-dom";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import AppSmallFooter from "components/AppSmallFooter/AppSmallFooter";
import AppFooter from "components/AppFooter/AppFooter";

interface LayoutFooterProps {
  noHeaderFooter: boolean;
  handleLangChange: (newLang: string) => void;
  smallWindow: boolean;
  language: string;
}

export function LayoutFooter({
  noHeaderFooter,
  handleLangChange,
  smallWindow,
  language,
}: LayoutFooterProps) {
  const location = useLocation();
  if (noHeaderFooter) {
    return null;
  }

  if (
    TalaeraRoutes.SESSION_CONVERSATION.equals(location.pathname) ||
    TalaeraRoutes.POST_FEEDBACK.equals(location.pathname)
  ) {
    return <AppSmallFooter />;
  }

  return (
    <AppFooter
      currentLanguage={language}
      onLangChange={handleLangChange}
      smallWindow={smallWindow}
      navLinkClassName="webapp"
      style={{ bottom: 0 }}
    />
  );
}
